<template>
  <div class="review-modal">
    <div class="booking-requested">
      <div class="success-gif-container">
        <img
          src="@/assets/timeslot-images/4386-connection-error.gif"
          loading="lazy"
          width="170"
          alt=""
        />
      </div>
      <div
        data-w-id="caac9a15-5baa-ef5a-3411-d43737a55cc4"
        class="link-block-5 w-inline-block"
      >
        <img
          @click="cancel"
          src="@/assets/timeslot-images/cancel.svg"
          loading="lazy"
          alt=""
        />
      </div>
      <div class="div-block-52">
        <h1 class="modal-heading">Review denied</h1>
      </div>
      <p class="paragraph-7">
        Reviews can only be given after a session with a professional. Book this
        professional to enable review.
      </p>
      <!--      <div-->
      <!--          data-w-id="caac9a15-5baa-ef5a-3411-d43737a55cdc"-->
      <!--          class="button-15 w-button"-->
      <!--          @click="buttonAction"-->
      <!--      >-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "ReviewRestrictionModal",
  props: {
    buttonAction: Function,
    cancel: Function
  }
};
</script>

<style scoped>
.success-gif-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
